import React from 'react';
import PropTypes from 'prop-types';
import {Icons} from '@learningblocks/exp-constants';
import './style.scss';

const {AlertLargeSuccess: ListIcon} = Icons;

export function SummaryList(props) {
  const renderListItem = (summaryItem, key) => (
    <li key={key} className='summaryList__listblock_item'>
      <ListIcon className='summaryList__listblock_item_icon' />
      <p className='summaryList__listblock_item_text'>{summaryItem}</p>
    </li>
  );

  return (
    <div className='summaryList'>
      <div className='summaryList__titleblock'>
        <h6 className='summaryList__titleblock_title'>{props.title}</h6>
      </div>
      <ul className='summaryList__listblock'>
        {props.list.map(renderListItem)}
      </ul>
    </div>
  );
}

SummaryList.propTypes = {
  /**
   * Title of the list
   */
  title: PropTypes.string,
  /**
   * List of summary Items
   */
  list: PropTypes.arrayOf(PropTypes.string),
};
